/**
 * Event Bus Service
 *
 * Modern event emitter using mitt to replace Vue 2's deprecated $on/$off patterns.
 * This provides a centralized event system for cross-component communication.
 *
 * Usage:
 * - In Vue components: this.$eventBus.emit('eventName', data)
 * - In Composition API: const eventBus = inject('eventBus'); eventBus.emit('eventName', data)
 * - For listening: eventBus.on('eventName', handler) with proper cleanup in onUnmounted
 */

import mitt from "mitt";

// Create the event emitter instance
export const eventBus = mitt();

// Export default for easy importing
export default eventBus;
